import React from "react";
import { Button, Modal } from "@components";
import styles from "./ConfirmModal.module.scss";
export function ConfirmModal({ isOpen, title, message, saveBtnText, cancelBtnText, onSave, onClose, onCancel, }) {
    const buttons = (React.createElement(React.Fragment, null,
        React.createElement(Button, { variant: "outlined", color: "tertiary", onClick: onCancel }, cancelBtnText || "Cancel"),
        React.createElement(Button, { onClick: onSave }, saveBtnText || "Save")));
    return (isOpen && (React.createElement(Modal, { open: isOpen, title: title, className: styles.modal, onRequestClose: onClose, content: React.createElement("div", { className: styles.message }, message), footerContent: buttons })));
}
